<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import type { ComboboxRootEmits, ComboboxRootProps } from 'radix-vue';
import { ComboboxRoot, useForwardPropsEmits } from 'radix-vue';
import { cn } from '@laam/lib/utils';

const props = withDefaults(
	// eslint-disable-next-line vue/require-default-prop
	defineProps<ComboboxRootProps & { class?: HTMLAttributes['class'] }>(),
	{
		open: true,
		modelValue: '',
	},
);

const emits = defineEmits<ComboboxRootEmits>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<ComboboxRoot
		v-bind="forwarded"
		:class="
			cn(
				'flex h-full w-full flex-col overflow-hidden rounded-medium  text-neutral-950',
				props.class,
			)
		"
	>
		<slot />
	</ComboboxRoot>
</template>
